export default __webpack_public_path__ + "static/media/logo.851f7805.png";